<template>
  <div>
    <b-alert :show="true" variant="light">
      <div class="iq-alert-text">
        {{ clientInfo.firstName }} {{ clientInfo.middleName }}
        {{ clientInfo.lastName }} <br />
        {{ clientInfo.mobileNumber }}<br />
        {{ clientInfo.email }}
      </div>
    </b-alert>
  </div>
</template>
<script>
export default {
  name: 'WDClient',
  props: ['clientInfo']
}
</script>
